// extracted by mini-css-extract-plugin
export default {"styles":"styles___EnfUk","FFeather":"FFeather___DYGO6"};